(function ($, Drupal, once) {
  Drupal.behaviors.mobileMenuToggle = {
    attach: function attach() {
      $(once('mobile-menu-toggle', '.js-mobile-menu-toggle')).each(function () {
        const $nav = $('.mobile-menu');
        $nav.attr('aria-dialog', 'true');
        $nav.attr('tabindex', '-1');
        const $mobileNavToggle = $(this);
        const openClass = 'nav-open';

        $mobileNavToggle.on('click', function () {
          if ($nav.hasClass(openClass)) {
            $nav.removeClass(openClass);
            $mobileNavToggle.removeClass(openClass);
            $('.ui-widget-overlay').remove();
          } else {
            $nav.addClass(openClass);
            $mobileNavToggle.addClass(openClass);
            $nav.trigger('focus');
            $('body').append('<div class="ui-widget-overlay active"></div>');
          }
        });
      });
    },
  };
}(jQuery, Drupal, once));
